<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zEvdBX/tc-custom/9781429954167.jpg?1737765587510" alt="This image is the cover for the book Dark Jenny, The Eddie LaCrosse Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dark Jenny, The Eddie LaCrosse Novels
      </h1>
      <p class="bookDescription body article font2">
        <p> Alex Bledsoe's novels featuring detective Eddie LaCrosse have drawn rave reviews for their ingenious blend of classic fantasy and hard-boiled detective fiction. Now with <i>Dark Jenny</i>, Bledsoe returns with an all-new tale of intrigue and murder. . . .<br/><br/> For twenty-five gold pieces a day, plus expenses, Eddie LaCrosse will take on most any case. But the unexpected delivery of a coffin in the dead of winter forces LaCrosse to look back at a bygone chapter in his past—and the premeditated murder of a dream.<br/><br/> Ruled by the noble King Marcus Drake, the island kingdom of Grand Braun is an oasis of peace and justice in an imperfect world. At least until the beautiful Queen Jennifer is accused of adultery and murder. In the wrong castle at the wrong time, Eddie finds himself drafted at sword's point to solve the mystery. With time running out, and powerful nobles all too eager to pin the murder on Eddie himself, he must untangle a tangled web of palace intrigues, buried secrets, and bewitching women—before the entire kingdom erupts into civil war.<br/><br/> Murder, mystery, and magic—just another day on the job for Eddie LaCrosse.<br/>   </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alex Bledsoe
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3a8a7856